export const PRIORITIES = {
  PRIMEVUE: 1,
  I18N: 2,
  PINIA: 3,
  ROUTER: 4,
  PERMISSION: 5,
  HTTP: 6,
  AMPLITUDE: 7,
  SESSION_EXPIRY: 8,
  SENTRY: 999,
}
